'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _widget = require('../widget');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * A higher-order component for turning a component into a zendesk widget
 * activator.
 *
 * @example
 *
 * // The `onActivate` prop is available because we've wrapped the component
 * // with the `asZendeskActivator` function
 * const MyComponent = function(props) {
 *      return <div onClick={props.onActivate}>Whatever I want here</div>;
 * }
 *
 * const MyWrappedComponent = asZendeskActivator(MyComponent);
 *
 * // later, in a render function....
 * render() {
 *      return <div>
 *          <MyWrappedComponent />
 *      </div>;
 * }
 *
 */
function asZendeskActivator(Component) {
    function ZendeskActivator(props) {
        return _react2['default'].createElement(Component, _extends({}, props, { onActivate: _widget.activate }));
    }

    var wrappedComponentName = Component.displayName || Component.name || 'Component';

    ZendeskActivator.displayName = 'asZendeskActivator(' + wrappedComponentName + ')';

    return ZendeskActivator;
}

exports['default'] = asZendeskActivator;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/common/zendesk/components/activator.js
 ** module id = 837
 ** module chunks = 0 1
 **/